/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  posHandler,
  authHandler,
  memberHandler,
  billHandler,
} from "../../../redux/handlers";
import * as _ from "lodash";
import { nanoid } from "nanoid";

import {
  setCurrentOrder,
  updateCurrentOrder,
  resetCurrentOrder,
  addProductToOrder,
  updateProductInOrder,
  removeProductFromOrder,
  markProductAsRemoved,
  calculateOrderTotals,
  setOrderId,
  setCurrentBillData,
  processPendingTableOrder,
  setShouldOpenPaymentModal,
} from "../../../redux/slices/pos.slice";

import { clearRecallData } from "../../../redux/slices/bill.slice";
import POSHeader from "components/POSHeader";
import Order from "./Order";
import ProductPaginate from "components/modals/ProductPaginate";
import CategorySlide from "components/modals/CategorySlide";
import CategorySubSlide from "components/modals/CategorySubSlide";
import ModalChangeStaff from "components/modals/ChangeEmployeeModal";
import ModalPin from "components/modals/PinVerificationModal";
import ModalSuccess from "components/modals/ModalSuccess";
import ModalPayment from "components/modals/ModalPayment";
import ModalCallBill from "components/modals/ModalCallBill";
import ModalHoldBillConfirm from "components/modals/ModalHoldBillConfirm";
import ModalRemoveProductConfirm from "components/modals/ModalRemoveProductConfirm";
import ModalPaymentSuccess from "components/modals/ModalPaymentSuccess";
import ProductOrderConfigurationModal from "components/modals/ProductOrderConfigurationModal";
import ModalTableSelect from "components/modals/ModalTableSelect";
import ModalSearchMember from "components/modals/ModalSearchMember";
import ModalRegisterMember from "components/modals/ModalRegisterMember";
import ModalMemberRegisterSuccess from "components/modals/ModalMemberRegisterSuccess";
import ModalOrderRemark from "../../../components/layouts/ModalOrderRemark";

const initialOrderState = {
  orderNo: "",
  orderDate: "",
  tableID: "",
  zoneID: "",
  delivery: 2,
  memberID: null,
  memberName: "",
  product: [],
  orderPrice: {
    sumprice: 0.0,
    discount: 0.0,
    vat: 0.0,
    net: 0.0,
  },
  payment: [],
  tableDetails: null,
  billId: null,
  remark: "",
};

const deliveryOptions = [
  { value: 2, key: "TAKEAWAY", label: "กลับบ้าน" },
  { value: 1, key: "DINE_IN", label: "ทานที่ร้าน" },
  { value: 3, key: "DELIVERY ", label: "เดลิเวอรี่" },
];

const usePrevious = (state) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = state;
  }, [state]);
  return ref.current;
};

const getOrderType = (deliveryValue) => {
  const orderTypes = {
    2: "TAKEAWAY",
    1: "DINE_IN",
    3: "DELIVERY",
  };
  return orderTypes[deliveryValue] || "DINE_IN";
};

const transformOrderOptions = (options, type) => {
  if (!options || !options.length) return [];

  switch (type) {
    case "product":
      return options.map((option) => ({
        product_option_relation_id: option.categoryID,
        product_option_item_id: option.originalItemId || option.itemId,
        qty: option.optionQty || 1,
      }));
    case "specific":
      return options.map((option) => ({
        product_specific_option_relation_id: option.categoryID,
        product_specific_option_item_id: option.originalItemId || option.itemId,
        qty: option.optionQty || 1,
      }));
    case "annotation":
      return options.map((option) => ({
        product_annotation_relation_id: option.categoryID,
        product_annotation_item_id: option.originalItemId || option.itemId,
      }));
    default:
      return [];
  }
};

const transformOrderDataToRequestBody = (orderData, branchPosSellingId) => {
  const currentBranchId = localStorage.getItem("branchId");
  const requestBody = {
    branch_pos_selling_id: branchPosSellingId,
    member_id: orderData.memberID,
    branch_id: parseInt(currentBranchId),
    branch_table_id: orderData.tableID || null,
    order_type: getOrderType(orderData.delivery),
    remark: orderData.remark || "",
    orderItems: orderData.product
      .filter((product) => product.productStatus !== 4)
      .map((product) => ({
        product_id: product.productID,
        branch_kitchen_id: product.branchKitchenId || null,
        orderProductOption: transformOrderOptions(
          product.specificOptions,
          "product"
        ),
        orderProductSpecificOption: transformOrderOptions(
          product.standardOptions,
          "specific"
        ),
        orderProductAnnotation: transformOrderOptions(
          product.annotationOptions,
          "annotation"
        ),
        quantity: product.productQty || 1,
        price:
          parseFloat(
            product.displayPrice ||
              product.productSumPrice ||
              product.productPrice
          ) || 0,
        remark: product.note || "",
      })),
  };

  return requestBody;
};

const prepareOrderItemRequestBody = (productsToSend, orderId) => {
  return {
    order_id: parseInt(orderId),
    items: productsToSend.map((product) => ({
      product_id: product.productID,
      branch_kitchen_id: product.branchKitchenId || null,
      orderProductOption: transformOrderOptions(
        product.specificOptions,
        "product"
      ),
      orderProductSpecificOption: transformOrderOptions(
        product.standardOptions,
        "specific"
      ),
      orderProductAnnotation: transformOrderOptions(
        product.annotationOptions,
        "annotation"
      ),
      quantity: product.productQty || 1,
      price: parseFloat(product.displayPrice || product.productPrice) || 0,
      remark: product.note || "",
    })),
  };
};

export default function POS() {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();

  const {
    pos,
    currentOrder,
    orderId,
    currentBillData,
    pendingTableOrder,
    shouldOpenPaymentModal,
  } = useSelector((state) => state.pos);

  const customerList = useSelector((state) => state.member?.data || []);
  const { recallOrderData, recallOrderId } = useSelector((state) => state.bill);
  const orderSocket = useSelector((state) => state.kitchen.orderSocket);

  const currentBranchId = localStorage.getItem("branchId");
  const currentBranchPOSId = localStorage.getItem("branchPOSId") || "";

  const [arrayOfPhone, setArrayOfPhone] = useState([]);
  const [custSeletedIdCf, setCustSeletedIdCf] = useState();
  const fetchedBillOrderId = useRef();
  const childRef = useRef();

  const [selectedProductInfo, setSelectedProductInfo] = useState({});
  const [currentOrderItem, setCurrentOrderItem] = useState(false);
  const previousOrderItem = usePrevious(currentOrderItem);
  const [isProductEditMode, setIsProductEditMode] = useState(0);
  const [productSearchKeyword, setProductSearchKeyword] = useState("");
  const [activeCategoryId, setActiveCategoryId] = useState("");
  const [activeSubcategoryId, setActiveSubcategoryId] = useState("");
  const [availableProducts, setAvailableProducts] = useState([]);

  const [allAvailableProducts, setAllAvailableProducts] = useState([]);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [availableSubcategories, setAvailableSubcategories] = useState([]);

  const [isTableEmptyAlert, setIsTableEmptyAlert] = useState(false);
  const [isProductEmptyAlert, setIsProductEmptyAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("ดำเนินการสำเร็จ");
  const [modalStatus, setModalStatus] = useState("success");

  const [modalSearchMemberOpen, setmodalSearchMemberOpen] = useState(false);
  const [modalRegisterMemberOpen, setmodalRegisterMemberOpen] = useState(false);
  const [modalRegisterSuccess, setmodalRegisterSuccess] = useState(false);
  const [modalOrderRemark, setModalOrderRemark] = useState(false);
  const [activeEmployeeId, setActiveEmployeeId] = useState(null);
  const [modalStates, setModalStates] = useState({
    isTableSelectModalOpen: false,
    isPaymentModalOpen: false,
    isPaymentSuccessModalOpen: false,
    isCallBillModalOpen: false,
    isHoldBillConfirmModalOpen: false,
    isChangeStaffModalOpen: false,
    isPinModalOpen: false,
    isSuccessModalOpen: false,
    isProductOptionModalOpen: false,
    isRemoveProductConfirmModalOpen: false,
  });

  const previousOrderState = usePrevious(currentOrder);
  const isLoadingData = useRef(false);

  const filteredProductList = availableProducts.filter((product) => {
    if (!productSearchKeyword || productSearchKeyword.trim() === "") {
      return true;
    }

    const searchTerm = productSearchKeyword.toLowerCase().trim();

    const nameMatch =
      product.productName &&
      product.productName.toLowerCase().includes(searchTerm);

    const barcode = product.product?.barcode || "";
    const barcodeMatch = barcode !== "-" && barcode.includes(searchTerm);
    return nameMatch || barcodeMatch;
  });

  const updateModalState = useCallback((modalName, isOpen) => {
    setModalStates((prevStates) => ({ ...prevStates, [modalName]: isOpen }));
  }, []);

  const showSuccessModal = useCallback(
    (message, status = "success") => {
      setSuccessMessage(message);
      setModalStatus(status);
      updateModalState("isSuccessModalOpen", true);
    },
    [updateModalState]
  );

  const handleCalculateOrderTotals = useCallback(() => {
    if (currentOrder.product?.length > 0) {
      dispatch(calculateOrderTotals());
    }
  }, [dispatch, currentOrder.product]);

  const handleResetOrder = useCallback(() => {
    dispatch(resetCurrentOrder());
  }, [dispatch]);

  const fetchProductCategories = useCallback(() => {
    if (!businessSlug || !currentBranchPOSId) return;

    dispatch(posHandler.getProductCategories(businessSlug, currentBranchPOSId))
      .then((result) => {
        if (result?.productCategories?.length > 0) {
          const categoryListWithAll = [
            { category_id: "", category_name: "ทั้งหมด" },
            { category_id: "recommended", category_name: "สินค้าแนะนำ" },
            ...result.productCategories.map((category) => ({
              category_id: category.id,
              category_name: category?.name,
            })),
          ];

          setAvailableCategories(categoryListWithAll);
          setActiveCategoryId("");
          fetchBranchProducts();
        }
      })
      .catch((error) => console.error("Error fetching categories:", error));
  }, [businessSlug, currentBranchPOSId, dispatch]);

  const fetchProductSubcategories = useCallback(
    (categoryId) => {
      if (!businessSlug || !currentBranchId || !categoryId) return;

      dispatch(
        posHandler.getProductSubCategories(
          businessSlug,
          categoryId,
          currentBranchPOSId
        )
      )
        .then((result) => {
          if (result?.productSubCategories) {
            const subcategoryListWithAll = [
              { subcategory_id: "", subcategory_name: "ทั้งหมด" },
              ...result.productSubCategories.map((subcategory) => ({
                subcategory_id: subcategory.id,
                subcategory_name: subcategory?.name,
              })),
            ];

            setAvailableSubcategories(subcategoryListWithAll);
            setActiveSubcategoryId("");
            fetchBranchProducts(categoryId);
          }
        })
        .catch((error) =>
          console.error("Error fetching subcategories:", error)
        );
    },
    [businessSlug, currentBranchId, currentBranchPOSId, dispatch]
  );

  const fetchBranchProducts = useCallback(
    (categoryId, subcategoryId) => {
      if (!businessSlug || !currentBranchId) return;

      const requestParams = {
        page: 1,
        perPage: 1000000,
        productCategoryId: categoryId || undefined,
        productSubCategoryId: subcategoryId || undefined,
        searchTerm: productSearchKeyword || undefined,
      };
      
      if (categoryId === "recommended") {
        requestParams.isRecommended = true;
      }

      dispatch(
        posHandler.getPaginatedBranchProducts(
          businessSlug,
          currentBranchId,
          requestParams
        )
      )
        .then((result) => {
          if (result) {
            const formattedProductList = result.data.map((item) => {
              const branchKitchenId =
                item.product?.branchKitchenProduct?.[0]?.branch_kitchen_id ||
                null;

              const useDeliveryPrice = currentOrder.delivery === 3;
              return {
                productID: item.product.id,
                productName: item.product?.name,
                productPrice: useDeliveryPrice
                  ? parseFloat(
                      item.data?.price_delivery || item.product?.price_delivery
                    )
                  : item.data?.price || parseFloat(item.product.price),
                productImage: item.product.image_path,
                productBarcode: item.product.barcode,
                productSKU: item.product.sku,
                productAnnotation: item.product.annotation,
                isActive: item.is_active,
                id: item.id,
                product: item.product,
                data: item.data,
                branchKitchenId: branchKitchenId,
              };
            });

            setAvailableProducts(formattedProductList);

            if (!categoryId && !subcategoryId && !productSearchKeyword) {
              setAllAvailableProducts(formattedProductList);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
        });
    },
    [
      businessSlug,
      currentBranchId,
      dispatch,
      productSearchKeyword,
      currentOrder.delivery,
    ]
  );

  const processOrderItems = useCallback(
    (orderItems) => {
      if (!orderItems || !orderItems.length) return [];

      return orderItems.map((item) => {
        const productInfo =
          allAvailableProducts.find((p) => p.productID === item.product_id) ||
          {};

        let branchKitchenId = item.branch_kitchen_id || null;

        if (
          !branchKitchenId &&
          productInfo.product?.branchKitchenProduct?.length > 0
        ) {
          branchKitchenId =
            productInfo.product.branchKitchenProduct[0].branch_kitchen_id ||
            null;
        }

        if (!branchKitchenId) {
          branchKitchenId = productInfo.branchKitchenId || null;
        }

        const specificOptions = (item.orderProductOption || []).map((opt) => ({
          categoryID: opt.product_option_relation_id,
          itemId: opt.product_option_item_id,
          originalItemId: opt.product_option_item_id,
          itemPrice: opt.productOptionItem?.price || 0,
          optionQty: opt.qty || 1,
          itemName: opt.productOptionItem?.name || "",
        }));

        const standardOptions = (item.orderProductSpecificOption || []).map(
          (opt) => ({
            categoryID: opt.product_specific_option_relation_id,
            itemId: opt.product_specific_option_item_id,
            originalItemId: opt.product_specific_option_item_id,
            itemPrice: opt.productSpecificOptionItem?.price || 0,
            optionQty: opt.qty || 1,
            itemName: opt.productSpecificOptionItem?.name || "",
          })
        );

        const annotationOptions = (item.orderProductAnnotation || []).map(
          (opt) => ({
            categoryID: opt.product_annotation_relation_id,
            itemId: opt.product_annotation_item_id,
            originalItemId: opt.product_annotation_item_id,
            itemName: opt.productAnnotationItem?.name || "",
          })
        );

        let productStatus = 1;

        switch (item.status_kitchen) {
          case "PENDING":
            if (
              Number(item?.quantity) - Number(item?.quantity_removed) <
              Number(item?.quantity)
            ) {
              productStatus = 3;
            } else {
              productStatus = 1;
            }
            break;
          case "SUCCESS":
            productStatus = 2;
            break;
          case "CANCEL":
            productStatus = 3;
            break;
          case "ORDER_CANCEL":
            productStatus = 4;
            break;
          default:
            productStatus = 1;
        }

        let prevUnit = null;
        let prevPrice = null;
        let newPrice = item.price;
        prevUnit = Number(item?.quantity);

        prevPrice = item.price;

        let optionPricePerUnit = 0;

        if (item.orderProductOption && item.orderProductOption.length > 0) {
          item.orderProductOption.forEach((option) => {
            if (option.productOptionItem) {
              optionPricePerUnit +=
                parseFloat(option.qty || 0) *
                parseFloat(option.productOptionItem.price || 0);
            }
          });
        }

        if (
          item.orderProductSpecificOption &&
          item.orderProductSpecificOption.length > 0
        ) {
          item.orderProductSpecificOption.forEach((option) => {
            if (option.productSpecificOptionItem) {
              optionPricePerUnit +=
                parseFloat(option.qty || 0) *
                parseFloat(option.productSpecificOptionItem.price || 0);
            }
          });
        }

        const useDeliveryPrice = currentOrder.delivery === 3;
        let productBasePrice = 0;
        if (useDeliveryPrice) {
          productBasePrice =
            productInfo.data?.price_delivery ||
            productInfo.product?.price_delivery ||
            0;
        } else {
          productBasePrice = parseFloat(
            productInfo.data?.price || item.product?.price || 0
          );
        }
        const pricePerUnit =
          Number(productBasePrice) + Number(optionPricePerUnit);
        const remainingQuantity =
          Number(item.quantity) - Number(item.quantity_removed);
        newPrice = (pricePerUnit * remainingQuantity).toFixed(2);
        if (Number(item?.quantity) - Number(item?.quantity_removed) === 0) {
          productStatus = 4;
        }

        return {
          id: nanoid(),
          orderId: item.id,
          productID: item.product_id,
          productName:
            productInfo.productName || item.product?.name || "Unknown Product",
          productPrice: parseFloat(item.product?.price || 0),
          displayPrice: newPrice,
          productSumPrice: item.price,
          productQty: Number(item?.quantity) - Number(item?.quantity_removed),
          prevUnit: Number(item?.quantity_removed) === 0 ? null : prevUnit,
          prevPrice: Number(item?.quantity_removed) === 0 ? null : prevPrice,
          productStatus: productStatus,
          productImage: productInfo.productImage || item.product?.image_path,
          specificOptions: specificOptions,
          standardOptions: standardOptions,
          annotationOptions: annotationOptions,
          note: item.remark || "",
          branchKitchenId: branchKitchenId,
        };
      });
    },
    [allAvailableProducts]
  );

  const loadOrderData = useCallback(
    async (dismissLoadingState = false) => {
      if (!orderId || isLoadingData.current) {
        return;
      }

      isLoadingData.current = true;

      if (orderId && businessSlug) {
        try {
          const response = await dispatch(
            posHandler.getOrderById(businessSlug, orderId, dismissLoadingState)
          );

          if (response) {
            let updatedOrder = { ...initialOrderState };

            if (response.code) {
              updatedOrder.orderNo = response.code;
            }

            if (response.remark) {
              updatedOrder.remark = response.remark;
            }

            if (response.bill && response.bill.length > 0) {
              updatedOrder.billId = response.bill[0].id;

              try {
                const billResponse = await dispatch(
                  billHandler.getBillById(
                    businessSlug,
                    response.bill[0].id,
                    0,
                    0,
                    dismissLoadingState
                  )
                );
                fetchedBillOrderId.current = billResponse?.order?.id;
                if (billResponse) {
                  updatedOrder.billStatus = billResponse.status;

                  dispatch(
                    setCurrentBillData({
                      id: billResponse.id,
                      status: billResponse.status,
                      taxable_amount: billResponse.taxable_amount || 0,
                      vat: billResponse.vat || 0,
                      total_amount: billResponse.total_amount || 0,
                    })
                  );
                }
              } catch (billError) {
                console.error("Error fetching bill details:", billError);
              }
            }

            if (response.branchTable) {
              updatedOrder.tableID = response.branch_table_id;
              updatedOrder.zoneID = response.branchTable.branch_table_zone_id;
              updatedOrder.tableDetails = {
                tableID: response.branch_table_id,
                tableName: response.branchTable.name,
                zoneID: response.branchTable.branch_table_zone_id,
                zoneName: response.branchTable.branchTableZone?.name || "",
                seatCapacity: response.branchTable.seat_capacity,
                status: response.branchTable.status,
              };
            } else if (response.table_id) {
              updatedOrder.tableID = response.table_id;
            }

            if (response.member_id) {
              updatedOrder.memberID = response.member_id;

              try {
                const memberData = await dispatch(
                  memberHandler.getMemberById(businessSlug, response.member_id)
                );
                if (memberData) {
                  updatedOrder.memberName = `${
                    memberData.first_name_th || ""
                  } ${memberData.last_name_th || ""}`.trim();
                }
              } catch (memberError) {
                console.error("Error fetching member details:", memberError);
              }
            }

            if (response.order_type) {
              let deliveryValue = 1;
              switch (response.order_type) {
                case "DINE_IN":
                  deliveryValue = 1;
                  break;
                case "TAKEAWAY":
                  deliveryValue = 2;
                  break;
                case "DELIVERY":
                  deliveryValue = 3;
                  break;
                default:
                  deliveryValue = 1;
              }
              updatedOrder.delivery = deliveryValue;
            }

            let processedItems = [];
            if (response.orderItems && response.orderItems.length > 0) {
              processedItems = processOrderItems(response.orderItems);
            }

            const oldProduct = currentOrder?.product;
            processedItems = processedItems?.map((item, index) => {
              let imgPath = "";

              if (
                item &&
                item.productImage &&
                typeof item.productImage === "string"
              ) {
                if (!item.productImage.includes("https://")) {
                  if (
                    oldProduct &&
                    Array.isArray(oldProduct) &&
                    oldProduct[index]
                  ) {
                    imgPath = oldProduct[index].productImage || "";
                  }
                } else {
                  imgPath = item.productImage;
                }
              } else if (
                oldProduct &&
                Array.isArray(oldProduct) &&
                oldProduct[index]
              ) {
                imgPath = oldProduct[index].productImage || "";
              }
              return {
                ...item,
                productImage: imgPath,
              };
            });

            dispatch(
              setCurrentOrder({
                ...updatedOrder,
                product: processedItems,
                orderID: fetchedBillOrderId,
              })
            );
          }
        } catch (error) {
          console.error("Error loading order data:", error);
        } finally {
          isLoadingData.current = false;
        }
      }
    },
    [dispatch, businessSlug, processOrderItems, orderId]
  );

  const handleOrdersFromBill = useCallback(
    (billData) => {
      updateModalState("isCallBillModalOpen", false);
      if (billData.__resetBeforeLoad) {
        dispatch(setOrderId(billData.billID));
        setTimeout(() => {
          loadOrderData();
        }, 100);
      } else {
        dispatch(setOrderId(null));
        dispatch(
          setCurrentOrder({
            ...initialOrderState,
            product: billData.rawOrderData.product || [],
            orderPrice:
              billData.rawOrderData.orderPrice || initialOrderState.orderPrice,
            orderNo: billData.rawOrderData.orderNo || "",
            tableID: billData.rawOrderData.tableID || "",
            zoneID: billData.rawOrderData.zoneID || "",
            tableDetails: billData.rawOrderData.tableDetails || null,
            memberID: billData.rawOrderData.customerID || null,
            memberName: billData.rawOrderData.customerName || "",
            delivery: billData.delivery || 2,
            billId: billData.rawOrderData.billId || null,
            remark: billData.rawOrderData.remark || "",
          })
        );
      }
    },
    [loadOrderData, dispatch, updateModalState]
  );

  const submitOrderToKitchen = useCallback(async () => {
    let branchPosSellingId;
    if (pos?.length > 0 && pos[0].branchPosSelling?.length > 0) {
      branchPosSellingId = pos[0].branchPosSelling[0].id;
    }

    const productsToSend = currentOrder.product.filter(
      (product) => product.productStatus === 0
    );

    if (productsToSend.length === 0) {
      return;
    }

    try {
      let response;

      if (orderId) {
        const orderItemData = prepareOrderItemRequestBody(
          productsToSend,
          orderId
        );

        response = await dispatch(
          posHandler.createOrderItem(businessSlug, orderItemData)
        );

        if (response && response.orderItems && response.orderItems.length > 0) {
          dispatch(
            updateCurrentOrder({
              product: currentOrder.product.map((product) =>
                productsToSend.some((p) => p.id === product.id)
                  ? { ...product, productStatus: 1 }
                  : product
              ),
            })
          );

          setTimeout(() => {
            loadOrderData();
          }, 100);
        }
      } else {
        const orderToSend = {
          ...currentOrder,
          product: productsToSend,
        };

        const orderDataForAPI = transformOrderDataToRequestBody(
          orderToSend,
          branchPosSellingId
        );

        response = await dispatch(
          posHandler.createOrder(businessSlug, orderDataForAPI)
        );

        if (response && response.id) {
          const newOrderId = response.id;

          dispatch(setOrderId(newOrderId));

          setTimeout(() => {
            loadOrderData();
          }, 100);
        }
      }

      showSuccessModal("ส่งออเดอร์ไปยังครัวสำเร็จ");
      return response;
    } catch (error) {
      console.error("Error sending order to kitchen:", error);
    }
  }, [
    currentOrder,
    businessSlug,
    dispatch,
    loadOrderData,
    pos,
    showSuccessModal,
    orderId,
  ]);

  const handleUpdateOrderRemark = useCallback(
    async (remark) => {
      if (orderId) {
        try {
          const response = await dispatch(
            posHandler.updateOrderRemark(businessSlug, orderId, { remark })
          );

          if (response) {
            dispatch(updateCurrentOrder({ remark }));
            showSuccessModal("อัพเดทข้อมูล Remark สำเร็จ");
          }
          return response;
        } catch (error) {
          console.error("Error updating order remark:", error);
          showSuccessModal("เกิดข้อผิดพลาด ไม่สามารถอัพเดท Remark ได้", "fail");
        }
      } else {
        dispatch(updateCurrentOrder({ remark }));
      }
    },
    [businessSlug, dispatch, orderId, showSuccessModal]
  );

  const removeProductOrders = useCallback(
    async (orderItem) => {
      updateModalState("isRemoveProductConfirmModalOpen", false);
      if (orderItem.productStatus === 0) {
        dispatch(removeProductFromOrder(orderItem.id));
        updateModalState("isProductOptionModalOpen", false);
        return;
      }

      if (currentOrderItem && currentOrderItem.productStatus !== 4) {
        if (orderId && currentOrderItem.orderId) {
          try {
            updateModalState("isProductOptionModalOpen", false);

            await dispatch(
              posHandler.deleteOrderItem(businessSlug, currentOrderItem.orderId)
            );

            await loadOrderData();
            showSuccessModal("ลบรายการสินค้าสำเร็จ");
          } catch (error) {
            console.error("Error deleting order item:", error);
          }
        } else {
          updateModalState("isProductOptionModalOpen", false);
          dispatch(markProductAsRemoved(currentOrderItem.id));
        }
      } else {
        updateModalState("isProductOptionModalOpen", false);
      }
    },
    [
      businessSlug,
      currentOrderItem,
      dispatch,
      updateModalState,
      loadOrderData,
      showSuccessModal,
      orderId,
    ]
  );

  const handleHoldBillConfirm = useCallback(async () => {
    childRef.current.triggerRefresh();
    try {
      let branchPosSellingId;
      if (pos?.length > 0 && pos[0].branchPosSelling?.length > 0) {
        branchPosSellingId = pos[0].branchPosSelling[0].id;
      }

      const holdOrderRequest = {
        branch_pos_selling_id: parseInt(branchPosSellingId),
        order_type: getOrderType(currentOrder.delivery),
        meta_data: {
          product: currentOrder.product.filter(
            (item) => item.productStatus !== 4
          ),
          orderPrice: currentOrder.orderPrice,
          orderNo: currentOrder.orderNo,
          tableID: currentOrder.tableID,
          zoneID: currentOrder.zoneID,
          tableDetails: currentOrder.tableDetails,
          memberID: currentOrder.memberID,
          memberName: currentOrder.memberName,
          billId: currentOrder.billId,
          remark: currentOrder.remark,
        },
        status: "PENDING",
      };

      await dispatch(
        posHandler.createHoldOrder(businessSlug, holdOrderRequest)
      );

      dispatch(setOrderId(null));
      dispatch(resetCurrentOrder());

      updateModalState("isHoldBillConfirmModalOpen", false);
      showSuccessModal("พักบิลสำเร็จ");
    } catch (error) {
      console.error("Error holding bill:", error);
    }
  }, [
    currentOrder,
    businessSlug,
    dispatch,
    updateModalState,
    pos,
    showSuccessModal,
  ]);

  const handleHoldBillRequest = useCallback(() => {
    if (currentOrder.orderNo) {
      showSuccessModal(
        "ไม่สามารถพักบิลได้เนื่องจากมีหมายเลขออเดอร์แล้ว",
        "fail"
      );
      return;
    }

    if (!currentOrder.product || currentOrder.product.length === 0) {
      showSuccessModal(
        "ไม่สามารถพักบิลได้เนื่องจากไม่มีรายการสินค้าในออเดอร์",
        "fail"
      );
      return;
    }
    updateModalState("isHoldBillConfirmModalOpen", true);
  }, [
    updateModalState,
    currentOrder.orderNo,
    showSuccessModal,
    currentOrder?.product?.length,
  ]);

  const handlePaymentRequest = useCallback(() => {
    updateModalState("isPaymentModalOpen", true);
  }, [updateModalState]);

  const handleProductSelection = useCallback(
    (productItem) => {
      setSelectedProductInfo(productItem);
      setIsProductEditMode(0);

      const branchKitchenId =
        productItem.product?.branchKitchenProduct?.[0]?.branch_kitchen_id ||
        null;

      setCurrentOrderItem({
        id: nanoid(),
        productID: productItem.productID,
        productImage: productItem.productImage,
        productName: productItem.productName,
        productPrice: productItem.productPrice,
        productSumPrice: productItem.productPrice,
        productQty: 1,
        productStatus: 0,
        optionnote: [],
        optionproduct: [],
        optionstandard: [],
        note: "",
        branchKitchenId: branchKitchenId,
      });

      updateModalState("isProductOptionModalOpen", true);
    },
    [updateModalState]
  );

  const handleEditOrderItem = useCallback(
    (orderItem) => {
      const matchingProductInfo = allAvailableProducts.find(
        (product) => product.productID === orderItem.productID
      );

      if (matchingProductInfo) {
        setSelectedProductInfo(matchingProductInfo);
      }

      setCurrentOrderItem(orderItem);
      setIsProductEditMode(1);
      updateModalState("isProductOptionModalOpen", true);
    },
    [allAvailableProducts, updateModalState]
  );

  const handleAddProductToOrder = useCallback(async () => {
    if (isProductEditMode === 1 && currentOrderItem.productStatus === 1) {
      if (orderId) {
        try {
          const updateData = {
            quantity: parseInt(currentOrderItem.productQty),
            price: currentOrderItem.productSumPrice,
          };

          await dispatch(
            posHandler.updateOrderItem(
              businessSlug,
              currentOrderItem.orderId,
              updateData
            )
          );

          dispatch(
            updateProductInOrder({
              id: currentOrderItem.id,
              productData: currentOrderItem,
            })
          );

          await loadOrderData();
          showSuccessModal("อัพเดทรายการสำเร็จ");
        } catch (error) {
          console.error("Error updating order item:", error);
        }
      }
    } else if (isProductEditMode === 1) {
      dispatch(
        updateProductInOrder({
          id: currentOrderItem.id,
          productData: currentOrderItem,
        })
      );
    } else {
      dispatch(addProductToOrder({ ...currentOrderItem }));
    }

    updateModalState("isProductOptionModalOpen", false);
    setIsProductEmptyAlert(false);
  }, [
    currentOrderItem,
    isProductEditMode,
    updateModalState,
    businessSlug,
    dispatch,
    loadOrderData,
    showSuccessModal,
    orderId,
  ]);

  const showRemoveProductConfirm = useCallback(
    (orderItem) => {
      if (orderItem.productStatus === 0) {
        removeProductOrders(orderItem);
      } else {
        updateModalState("isRemoveProductConfirmModalOpen", true);
      }
    },
    [updateModalState, removeProductOrders]
  );

  const closeRemoveProductConfirm = useCallback(() => {
    updateModalState("isRemoveProductConfirmModalOpen", false);
  }, [updateModalState]);

  const addMemberToOrder = useCallback(
    (memberId, memberName) => {
      if (memberId) {
        dispatch(
          updateCurrentOrder({
            memberID: memberId,
            memberName: memberName,
          })
        );
      }
    },
    [dispatch]
  );

  const onRegisterSubmitHandler = useCallback(
    async (registerInfo) => {
      await dispatch(memberHandler.createMember(businessSlug, registerInfo));
      dispatch(memberHandler.getAllMember(businessSlug));
    },
    [dispatch, businessSlug]
  );

  const handleOpenOrderRemark = useCallback(() => {
    setModalOrderRemark(true);
  }, []);

  const handleOrderRemarkSubmit = useCallback(
    async (remark) => {
      if (orderId) {
        await handleUpdateOrderRemark(remark);
      } else {
        dispatch(
          updateCurrentOrder({
            remark: remark,
          })
        );
      }
      setModalOrderRemark(false);
    },
    [orderId, handleUpdateOrderRemark, dispatch]
  );

  useEffect(() => {
    if (shouldOpenPaymentModal) {
      loadOrderData();
      updateModalState("isPaymentModalOpen", true);
      dispatch(setShouldOpenPaymentModal(false));
    }
  }, [shouldOpenPaymentModal, updateModalState, dispatch]);

  useEffect(() => {
    if (pendingTableOrder) {
      dispatch(processPendingTableOrder());
    }
  }, [dispatch]);

  useEffect(() => {
    if (recallOrderId) {
      dispatch(setOrderId(recallOrderId));
      dispatch(clearRecallData());
    }
  }, [recallOrderId, dispatch]);

  useEffect(() => {
    if (recallOrderData) {
      dispatch(setCurrentOrder(recallOrderData));
      dispatch(clearRecallData());
    }
  }, [recallOrderData, dispatch]);

  useEffect(() => {
    const phoneNumbers = customerList.map((customer) => customer.phone_number);
    setArrayOfPhone(phoneNumbers);
  }, [customerList]);

  useEffect(() => {
    if (!custSeletedIdCf) return;

    const selectedMember = customerList.find(
      (member) => member.id === custSeletedIdCf
    );

    if (selectedMember) {
      dispatch(
        updateCurrentOrder({
          memberID: custSeletedIdCf,
          memberName: `${selectedMember.first_name_th || ""} ${
            selectedMember.last_name_th || ""
          }`.trim(),
        })
      );
    } else {
      dispatch(memberHandler.getMemberById(businessSlug, custSeletedIdCf))
        .then((memberData) => {
          if (memberData) {
            dispatch(
              updateCurrentOrder({
                memberID: custSeletedIdCf,
                memberName: `${memberData.first_name_th || ""} ${
                  memberData.last_name_th || ""
                }`.trim(),
              })
            );
          }
        })
        .catch((error) =>
          console.error("Error fetching member details:", error)
        );
    }
  }, [custSeletedIdCf, customerList, dispatch, businessSlug]);

  useEffect(() => {
    if (modalSearchMemberOpen && currentOrder.memberID) {
      setCustSeletedIdCf(currentOrder.memberID);
      dispatch(
        memberHandler.getMemberById(businessSlug, currentOrder.memberID)
      );
    }
  }, [modalSearchMemberOpen, currentOrder.memberID, dispatch, businessSlug]);

  useEffect(() => {
    if (
      previousOrderState &&
      !_.isEqual(currentOrder, previousOrderState) &&
      currentOrder.product?.length > 0
    ) {
      const hasProductChanges = !_.isEqual(
        currentOrder.product,
        previousOrderState.product
      );

      if (hasProductChanges) {
        handleCalculateOrderTotals();
      }
    }
  }, [currentOrder, previousOrderState, handleCalculateOrderTotals]);

  useEffect(() => {
    if (currentOrder.tableID && !currentOrder.tableDetails) {
      dispatch(
        updateCurrentOrder({
          tableDetails: {
            tableID: currentOrder.tableID,
            zoneID: currentOrder.zoneID,
          },
        })
      );
    }
  }, [currentOrder.tableID, currentOrder.tableDetails, dispatch]);

  useEffect(() => {
    if (activeCategoryId) {
      setActiveSubcategoryId("");      
      if (activeCategoryId === "recommended") {
        setAvailableSubcategories([
          { subcategory_id: "", subcategory_name: "ทั้งหมด" },
        ]);
      } else {
        fetchProductSubcategories(activeCategoryId);
      }
    } else {
      setAvailableSubcategories([
        { subcategory_id: "", subcategory_name: "ทั้งหมด" },
      ]);
      setActiveSubcategoryId("");
      fetchBranchProducts();
    }
  }, [activeCategoryId, fetchBranchProducts, fetchProductSubcategories]);

  useEffect(() => {
    if (activeCategoryId) {
      fetchBranchProducts(activeCategoryId, activeSubcategoryId || undefined);
    } else {
      fetchBranchProducts();
    }
  }, [
    activeSubcategoryId,
    productSearchKeyword,
    activeCategoryId,
    fetchBranchProducts,
  ]);

  useEffect(() => {
    if (availableProducts.length > 0 && orderId) {
      const shouldLoadData =
        !currentOrder.orderNo || currentOrder.product.length === 0;

      if (shouldLoadData) {
        loadOrderData();
      }
    }
  }, [
    availableProducts,
    loadOrderData,
    orderId,
    currentOrder.orderNo,
    currentOrder.product.length,
  ]);

  useEffect(() => {
    if (orderId) {
      loadOrderData(true);
    }
  }, [orderSocket, loadOrderData, orderId]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise.all([
          dispatch(authHandler.getUserBusinessProfile(businessSlug)),
          dispatch(posHandler.getBranchInfo(businessSlug, currentBranchId)),
          dispatch(posHandler.getBranchPosById(businessSlug, currentBranchId)),
        ]);
        fetchProductCategories();
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    if (businessSlug && currentBranchId) {
      fetchInitialData();
    }
  }, [businessSlug, currentBranchId, dispatch, fetchProductCategories]);

  useEffect(() => {
    async function checkBranchInfo() {
      const branchInfo = await dispatch(
        posHandler.getBranchInfo(businessSlug, currentBranchId)
      );
      if (
        branchInfo?.employee_info?.userBusinessGroup?.branchPosSelling[0]?.id
      ) {
        localStorage.setItem(
          "branchPOSSelling",
          branchInfo?.employee_info?.userBusinessGroup?.branchPosSelling[0]?.id
        );
      }
    }
    checkBranchInfo();
  }, [businessSlug, currentBranchId, dispatch]);

  return (
    <div className="h-100" id="ccvv">
      <div className="block-2">
        <POSHeader isSearch={true} setFilterText={setProductSearchKeyword} />
        <div className="px-3 pt-3 pb-2 d-flex flex-column bx-content">
          <>
            <CategorySlide
              categoryObj={{
                categoryID: activeCategoryId,
                setcategoryID: setActiveCategoryId,
              }}
              handleClick={(id) => {
                setActiveCategoryId(id);
                setActiveSubcategoryId("");
              }}
              categorys={availableCategories}
            />

            <CategorySubSlide
              categoryObj={{
                categoryID: activeSubcategoryId,
                setcategoryID: setActiveSubcategoryId,
              }}
              handleClick={(id) => setActiveSubcategoryId(id)}
              categorys={availableSubcategories}
            />
          </>

          <div className="d-flex flex-column mt-4" id="foodlist">
            <ProductPaginate
              items={filteredProductList}
              handleoptionShow={(item) => {
                handleProductSelection(item);
              }}
            />
          </div>
        </div>
      </div>
      <div className="block-3">
        <Order
          orderData={currentOrder}
          orderId={orderId}
          billData={currentBillData}
          isTableAlertVisible={isTableEmptyAlert}
          isProductAlertVisible={isProductEmptyAlert}
          handleEditProduct={handleEditOrderItem}
          handleHoldBill={handleHoldBillRequest}
          handlePayment={handlePaymentRequest}
          updateModalState={updateModalState}
          submitOrders={submitOrderToKitchen}
          resetOrder={handleResetOrder}
          deliveryOptions={deliveryOptions}
          setmodalSearchMemberOpen={setmodalSearchMemberOpen}
          businessSlug={businessSlug}
          availableProducts={allAvailableProducts}
          onOpenOrderRemark={handleOpenOrderRemark}
        />
      </div>

      <ModalOrderRemark
        modalOpenObj={{
          modalOpen: modalOrderRemark,
          setModalOpen: setModalOrderRemark,
        }}
        orderRemarkObj={{
          orderRemark: currentOrder.remark,
          setOrderRemark: (remark) => {
            dispatch(
              updateCurrentOrder({
                remark: remark,
              })
            );
          },
        }}
        onConfirm={handleOrderRemarkSubmit}
      />

      <ProductOrderConfigurationModal
        show={modalStates.isProductOptionModalOpen}
        orders={currentOrder}
        onHide={() => updateModalState("isProductOptionModalOpen", false)}
        productselect={selectedProductInfo}
        productOrder={currentOrderItem}
        prevProductOrder={previousOrderItem}
        edit={isProductEditMode}
        setProductOrder={setCurrentOrderItem}
        businessSlug={businessSlug}
        addProductOrders={handleAddProductToOrder}
        removeProductOrders={showRemoveProductConfirm}
      />
      <ModalPayment
        modalOpenObj={{
          modalOpen: modalStates.isPaymentModalOpen,
          setModalOpen: (value) =>
            updateModalState("isPaymentModalOpen", value),
        }}
        modalSuccessOpenObj={{
          modalOpen: modalStates.isPaymentSuccessModalOpen,
          setModalOpen: (value) =>
            updateModalState("isPaymentSuccessModalOpen", value),
        }}
        businessSlug={businessSlug}
        branchId={currentBranchId}
        orderData={currentOrder}
        resetOrder={handleResetOrder}
      />
      <ModalPaymentSuccess
        modalOpenObj={{
          modalOpen: modalStates.isPaymentSuccessModalOpen,
          setModalOpen: (value) =>
            updateModalState("isPaymentSuccessModalOpen", value),
        }}
        orders={currentOrder}
        handleClick={() => {
          handleResetOrder();
          updateModalState("isPaymentSuccessModalOpen", false);
        }}
      />
      <ModalCallBill
        modalOpenObj={{
          modalOpen: modalStates.isCallBillModalOpen,
          setModalOpen: (value) =>
            updateModalState("isCallBillModalOpen", value),
        }}
        modalSuccessOpenObj={{
          modalOpen: modalStates.isSuccessModalOpen,
          setModalOpen: (value) =>
            updateModalState("isSuccessModalOpen", value),
        }}
        alertObj={{
          alerttable: isTableEmptyAlert,
          setAlerttable: setIsTableEmptyAlert,
          alertproduct: isProductEmptyAlert,
          setAlertproduct: setIsProductEmptyAlert,
        }}
        setOrders={handleOrdersFromBill}
        businessSlug={businessSlug}
        currentBranchId={currentBranchId}
        ref={childRef}
      />
      <ModalHoldBillConfirm
        modalOpenObj={{
          modalOpen: modalStates.isHoldBillConfirmModalOpen,
          setModalOpen: (value) =>
            updateModalState("isHoldBillConfirmModalOpen", value),
        }}
        modalSuccessOpenObj={{
          modalOpen: modalStates.isSuccessModalOpen,
          setModalOpen: (value) =>
            updateModalState("isSuccessModalOpen", value),
        }}
        onConfirmHold={handleHoldBillConfirm}
      />
      <ModalRemoveProductConfirm
        isOpen={modalStates.isRemoveProductConfirmModalOpen}
        onClose={closeRemoveProductConfirm}
        onConfirm={removeProductOrders}
        productName={currentOrderItem ? currentOrderItem.productName : ""}
      />
      <ModalChangeStaff
        modalOpenObj={{
          modalOpen: modalStates.isChangeStaffModalOpen,
          setModalOpen: (value) =>
            updateModalState("isChangeStaffModalOpen", value),
        }}
        modalPinOpenObj={{
          modalOpen: modalStates.isPinModalOpen,
          setModalOpen: (value) => updateModalState("isPinModalOpen", value),
        }}
        selectedUserIdObj={{
          selectedUserId: activeEmployeeId,
          setSelectedUserId: setActiveEmployeeId,
        }}
      />
      <ModalPin
        modalOpenObj={{
          modalOpen: modalStates.isPinModalOpen,
          setModalOpen: (value) => updateModalState("isPinModalOpen", value),
        }}
        modalSuccessOpenObj={{
          modalOpen: modalStates.isSuccessModalOpen,
          setModalOpen: (value) =>
            updateModalState("isSuccessModalOpen", value),
        }}
      />
      <ModalSuccess
        modalOpenObj={{
          modalOpen: modalStates.isSuccessModalOpen,
          setModalOpen: (value) =>
            updateModalState("isSuccessModalOpen", value),
        }}
        message={successMessage}
        status={modalStatus}
      />
      <ModalTableSelect
        modalOpenObj={{
          modalOpen: modalStates.isTableSelectModalOpen,
          setModalOpen: (value) =>
            updateModalState("isTableSelectModalOpen", value),
        }}
        handleTableSelect={(tableSelected) => {
          dispatch(
            updateCurrentOrder({
              tableID: tableSelected.tableID,
              zoneID: tableSelected.zoneID,
              tableDetails: tableSelected.tableDetails,
            })
          );
          updateModalState("isTableSelectModalOpen", false);
          setIsTableEmptyAlert(false);
        }}
        businessSlug={businessSlug}
        currentCustomerCount={
          currentOrder?.product?.length > 0
            ? currentOrder.product.reduce(
                (total, item) =>
                  item.productStatus !== 4
                    ? total + parseInt(item.productQty || 1)
                    : total,
                0
              )
            : 1
        }
        currentOrder={currentOrder}
        onTableOpenSuccess={() =>
          setTimeout(() => {
            loadOrderData();
          }, 100)
        }
      />
      <ModalSearchMember
        customerList={customerList}
        setSelectIdCf={setCustSeletedIdCf}
        modalOpenObj={{
          modalOpen: modalSearchMemberOpen,
          setModalOpen: setmodalSearchMemberOpen,
        }}
        modalRegisterMemberOpenObj={{
          modalOpen: modalRegisterMemberOpen,
          setModalOpen: setmodalRegisterMemberOpen,
        }}
        businessSlug={businessSlug}
        currentMemberID={currentOrder.memberID}
        addMemberToOrder={addMemberToOrder}
        orderId={orderId}
      />
      <ModalRegisterMember
        modalOpenObj={{
          modalOpen: modalRegisterMemberOpen,
          setModalOpen: setmodalRegisterMemberOpen,
        }}
        modalSuccessOpenObj={{
          modalOpen: modalRegisterSuccess,
          setModalOpen: setmodalRegisterSuccess,
        }}
        onSubmit={onRegisterSubmitHandler}
        arrayOfPhone={arrayOfPhone}
        businessSlug={businessSlug}
      />
      <ModalMemberRegisterSuccess
        className={"min-w-[min(31.74vw,325px)] text-22"}
        modalOpenObj={{
          modalOpen: modalRegisterSuccess,
          setModalOpen: setmodalRegisterSuccess,
        }}
        setModalMemberSearch={setmodalSearchMemberOpen}
        contentText="สมัครสมาชิกสำเร็จ"
      />
    </div>
  );
}
